module.exports = __webpack_public_path__ + "img/insert_stc_number.269411bf.svg";